/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Participation_Agreement_DescInputs */

const en_admin_participation_agreement_desc = /** @type {(inputs: Admin_Participation_Agreement_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF document linked in the company registration. The “Stand” date is shown in the checkbox text.`)
};

const de_admin_participation_agreement_desc = /** @type {(inputs: Admin_Participation_Agreement_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF-Dokument, das in der Unternehmensregistrierung verlinkt wird. Das „Stand“-Datum wird im Checkbox-Text angezeigt.`)
};

/**
* | output |
* | --- |
* | "PDF document linked in the company registration. The “Stand” date is shown in the checkbox text." |
*
* @param {Admin_Participation_Agreement_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_participation_agreement_desc = /** @type {((inputs?: Admin_Participation_Agreement_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Participation_Agreement_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_participation_agreement_desc(inputs)
	return en_admin_participation_agreement_desc(inputs)
});